<template>
  <ScaleBox>
    <div class="mr-visual">
      <v-header-box></v-header-box>
      <div class="mr-visual-left">
        
      </div>
      <transition name="el-fade-in-linear">
        <div class="mr-visual-container">
          
        </div>
      </transition>
      <div class="mr-visual-right">
        
      </div>
      <div class="mr-visual-footer">
        <v-footer></v-footer>
      </div>
    </div>
  </ScaleBox>
</template>

<script lang="js">
import { mapState } from "vuex";
import VHeaderBox from "./components/v-header-box.vue";
import VFooter from "./components/v-footer.vue";
import ScaleBox from "@/components/view/scaleBox.vue";

export default {
  name: 'visual',
  components: {
    VHeaderBox,
    VFooter,
    ScaleBox
  },
  data() {
    return {
      projectCode: "", // 项目编号
    }
  },
  created() {
   
  },
  computed: {
    ...mapState(["projectCurrentRowData"])
  },
  mounted() {
    const currentData = this.projectCurrentRowData || {};
    this.projectCode = currentData.projectCode;
  },
  methods: {

  }
}
</script>
<style scoped lang="scss">

.stats-cards {
  width: 400px;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 10px;
}

.stat-card {
  background-color: #1e293b;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  margin-top: 20px;
}

.card-title {
  font-size: 24px;
  color: white;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.trend.down {
  margin-right: 4px;
  color: #22c55e;
  font-size: 18px;
}

.trend.up {
  margin-right: 4px;
  color: red;
  font-size: 18px;
}

.year-data {
  display: flex;
  flex-direction: column;
}

.year-item {
  margin-bottom: 5px;
  margin-top: 15px;
}

.year-label {
  font-size: 20px;
  color: #94a3b8;
  margin-bottom: 10px;
  margin-right: 20px;
}

.year-value {
  font-size: 22px;
  font-weight: bold;
}

.year-item:nth-child(1) .year-value {
  background: linear-gradient(to right, #22c55e, #34d399);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.year-item:nth-child(2) .year-value {
  background: linear-gradient(to right, #7e22ce, #a855f7);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.v-card {
  height: 100px;
  width: 320px;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 14px;
  border-radius: 1px;
  opacity: 1;
  background: rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  border: 1px solid;
  box-sizing: border-box;
  border-image: linear-gradient(119deg, rgba(0, 255, 200, 0.13) 40%, rgba(207, 236, 255, 0) 70%, rgba(184, 228, 255, 0.32) 112%) ;
  >.vc-list {
    >p {
      text-align: center;
      line-height: 24px;
    }
    >p:nth-child(1) {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 12px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.6);
    }
    >p:nth-child(2) {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 14px;
      letter-spacing: 0em;
      color: #FFFFFF;
      font-weight: 700;
    }
  }
}
.mr-visual {
  height: 100%;
  background: url("./images/zonghe_bg.jpg") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;

  .mr-visual-header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .mr-visual-left,
  .mr-visual-right,
  .mr-visual-container {
    position: absolute;
    height: 100%;
    opacity: 1;
    box-sizing: border-box;

    .scroll {
      height: 100%;

      >div {
        margin-bottom: 8px;
      }
    }
  }

  .mr-visual-container {
    width: 1344px;
    left: 13%;
    height: 100%;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .mr-visual-right {
    top: 80px;
    right: 0;
    width: 321.33px;
    box-sizing: border-box;
  }

  .mr-visual-left {
    top: 90px;
    left: 0;
    width: 255px;
    box-sizing: border-box;
    >div {
      margin-bottom: 8px;
    }
  }

  .mr-opt-dialog {
    position: absolute;
    left: -78px;
    top: 25%;
  }

  .mr-visual-footer {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
  }

  .popinfos {
    /* 矩形 411 */

    position: absolute;

    width: 264.12px;
    height: 144.56px;
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    box-shadow: inset 0px 4px 32px 0px rgba(0, 34, 255, 0.45);
    z-index: 1;
    padding: 20px 15px;

    P {
      width: 210px;
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      text-align: left;
      padding-left: 8px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 26px;

      font-weight: 600;
    }
  }
}
</style>
